import './table.css';
export default {
  "button": "pf-v6-c-button",
  "check": "pf-v6-c-check",
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "fixed": "pf-m-fixed",
    "stickyHeader": "pf-m-sticky-header",
    "nestedColumnHeader": "pf-m-nested-column-header",
    "striped": "pf-m-striped",
    "expandable": "pf-m-expandable",
    "stripedEven": "pf-m-striped-even",
    "ghostRow": "pf-m-ghost-row",
    "hidden": "pf-m-hidden",
    "hiddenOnSm": "pf-m-hidden-on-sm",
    "visibleOnSm": "pf-m-visible-on-sm",
    "hiddenOnMd": "pf-m-hidden-on-md",
    "visibleOnMd": "pf-m-visible-on-md",
    "hiddenOnLg": "pf-m-hidden-on-lg",
    "visibleOnLg": "pf-m-visible-on-lg",
    "hiddenOnXl": "pf-m-hidden-on-xl",
    "visibleOnXl": "pf-m-visible-on-xl",
    "hiddenOn_2xl": "pf-m-hidden-on-2xl",
    "visibleOn_2xl": "pf-m-visible-on-2xl",
    "center": "pf-m-center",
    "help": "pf-m-help",
    "favorite": "pf-m-favorite",
    "borderRight": "pf-m-border-right",
    "borderLeft": "pf-m-border-left",
    "action": "pf-m-action",
    "noBorderRows": "pf-m-no-border-rows",
    "expanded": "pf-m-expanded",
    "clickable": "pf-m-clickable",
    "selected": "pf-m-selected",
    "firstCellOffsetReset": "pf-m-first-cell-offset-reset",
    "dragOver": "pf-m-drag-over",
    "animateExpand": "pf-m-animate-expand",
    "noAnimateExpand": "pf-m-no-animate-expand",
    "truncate": "pf-m-truncate",
    "wrap": "pf-m-wrap",
    "nowrap": "pf-m-nowrap",
    "fitContent": "pf-m-fit-content",
    "breakWord": "pf-m-break-word",
    "standalone": "pf-m-standalone",
    "favorited": "pf-m-favorited",
    "noPadding": "pf-m-no-padding",
    "noBackground": "pf-m-no-background",
    "compact": "pf-m-compact",
    "borderRow": "pf-m-border-row",
    "width_10": "pf-m-width-10",
    "width_15": "pf-m-width-15",
    "width_20": "pf-m-width-20",
    "width_25": "pf-m-width-25",
    "width_30": "pf-m-width-30",
    "width_35": "pf-m-width-35",
    "width_40": "pf-m-width-40",
    "width_45": "pf-m-width-45",
    "width_50": "pf-m-width-50",
    "width_60": "pf-m-width-60",
    "width_70": "pf-m-width-70",
    "width_80": "pf-m-width-80",
    "width_90": "pf-m-width-90",
    "width_100": "pf-m-width-100"
  },
  "radio": "pf-v6-c-radio",
  "table": "pf-v6-c-table",
  "tableAction": "pf-v6-c-table__action",
  "tableButton": "pf-v6-c-table__button",
  "tableButtonContent": "pf-v6-c-table__button-content",
  "tableCaption": "pf-v6-c-table__caption",
  "tableCellEmpty": "pf-v6-c-table__cell-empty",
  "tableCheck": "pf-v6-c-table__check",
  "tableColumnHelp": "pf-v6-c-table__column-help",
  "tableColumnHelpAction": "pf-v6-c-table__column-help-action",
  "tableCompoundExpansionToggle": "pf-v6-c-table__compound-expansion-toggle",
  "tableControlRow": "pf-v6-c-table__control-row",
  "tableDraggable": "pf-v6-c-table__draggable",
  "tableExpandableRow": "pf-v6-c-table__expandable-row",
  "tableExpandableRowContent": "pf-v6-c-table__expandable-row-content",
  "tableFavorite": "pf-v6-c-table__favorite",
  "tableIcon": "pf-v6-c-table__icon",
  "tableIconInline": "pf-v6-c-table__icon-inline",
  "tableInlineEditAction": "pf-v6-c-table__inline-edit-action",
  "tableSort": "pf-v6-c-table__sort",
  "tableSortIndicator": "pf-v6-c-table__sort-indicator",
  "tableSubhead": "pf-v6-c-table__subhead",
  "tableTbody": "pf-v6-c-table__tbody",
  "tableTd": "pf-v6-c-table__td",
  "tableText": "pf-v6-c-table__text",
  "tableTh": "pf-v6-c-table__th",
  "tableThead": "pf-v6-c-table__thead",
  "tableToggle": "pf-v6-c-table__toggle",
  "tableToggleIcon": "pf-v6-c-table__toggle-icon",
  "tableTr": "pf-v6-c-table__tr"
};